export const botResponses = {
  // Greetings
  hello: {
    content: "Hello! 👋 I'm mahmud's AI assistant. How can I assist you today?",
    options: ['About mahmud', 'View Projects', 'Technical Skills', 'Contact mahmud']
  },
  hi: {
    content: "Hi there! 🌟 How can I help you explore mahmud's expertise?",
    options: ['Technical Skills', 'Portfolio', 'Availability', 'Work Process']
  },
  "how are you": {
    content: "I'm doing great! 💪 Ready to help you. What can I assist you with?",
    options: ['Recent Projects', 'Tech Stack', 'Client Feedback', 'Contact']
  },

  // About mahmud
  "who is mahmud": {
    content: "mahmud is a Full Stack Developer specializing in the MERN stack. With over 3 years of experience, he builds scalable applications, robust APIs, and dynamic user interfaces.",
    options: ['View Skills', 'See Projects', 'Client Reviews', 'Contact mahmud']
  },
  "where is mahmud": {
    content: "mahmud is based in Dhaka, Bangladesh, and collaborates with clients worldwide. Would you like to know more about his availability?",
    options: ['Contact mahmud', 'Time Zone', 'Work Culture', 'Start a Project']
  },

  // Skills & Expertise
  skills: {
    content: "mahmud's key technical skills include frontend (React.js, Next.js, TypeScript), backend (Node.js, Express.js, GraphQL), and DevOps (Docker, AWS, Vercel).",
    options: ['MERN Stack', 'Live Demos', 'GitHub Profile', 'Contact mahmud']
  },
  "MERN Stack": {
    content: "mahmud specializes in MERN stack development: MongoDB, Express.js, React.js, and Node.js.",
    options: ['See Projects', 'Learn More', 'Start a Project', 'Tech Blog']
  },
  "devops skills": {
    content: "mahmud has experience with Docker, Kubernetes, AWS, Vercel, and CI/CD pipelines.",
    options: ['See Deployment Projects', 'Consult on DevOps', 'GitHub Profile']
  },

  // Work Process
  "how to start": {
    content: "Getting started with mahmud is simple: Consultation, Proposal, Development, and Launch.",
    options: ['Schedule Call', 'View Process', 'Contact mahmud']
  },
  "work process": {
    content: "mahmud follows a structured workflow: Understanding Requirements, Wireframing, Development, Testing, Deployment, and Maintenance.",
    options: ['Start Project', 'Timeline', 'Pricing', 'View Portfolio']
  },

  // Projects
  projects: {
    content: "mahmud has worked on e-commerce platforms, social media apps, real-time applications, and admin dashboards.",
    options: ['Project Details', 'Live Demos', 'Tech Stack Used']
  },
  "project demo": {
    content: "Check out live demos of mahmud's projects: E-commerce Platform, Social Media App, Real-time Chat System, and Admin Dashboard.",
    options: ['E-commerce Platform', 'Social Media App', 'Real-time Chat', 'Admin Dashboard']
  },
  "custom projects": {
    content: "mahmud can build custom projects based on your needs: SaaS, marketplaces, dashboards, and more.",
    options: ['Request Custom Project', 'Consultation Call', 'View Portfolio']
  },

  // Pricing & Packages
  pricing: {
    content: "mahmud offers flexible pricing based on project complexity. Packages include Basic, Standard, and Premium options.",
    options: ['View Pricing', 'Get a Quote', 'Start a Project']
  },
  "get a quote": {
    content: "mahmud provides tailored pricing based on your project needs. Share your requirements to receive a quote.",
    options: ['Contact mahmud', 'Start a Project', 'View Process']
  },

  // Client Testimonials & Reviews
  "client feedback": {
    content: "Clients appreciate mahmud’s expertise, communication, and ability to deliver high-quality products on time.",
    options: ['Read Testimonials', 'See Case Studies', 'Contact mahmud']
  },
  "read testimonials": {
    content: "See what clients say about working with mahmud.",
    options: ['View Testimonials', 'Success Stories', 'Start a Project']
  },

  // Learning & Resources
  "learn mern": {
    content: "Interested in learning MERN stack? Follow this roadmap: JavaScript, React.js, Node.js, MongoDB.",
    options: ['Get Resources', 'View Projects', 'Contact mahmud']
  },
  "learning resources": {
    content: "mahmud recommends FreeCodeCamp, MDN Web Docs, React Docs, and Node.js Documentation.",
    options: ['View Projects', 'Get Resources', 'Tech Blog']
  },

  // Collaboration & Availability
  availability: {
    content: "mahmud is currently available for new projects. Want to start working together?",
    options: ['Check Schedule', 'Book a Meeting', 'Send an Inquiry']
  },
  "work culture": {
    content: "mahmud values clear communication, timely delivery, and high-quality code.",
    options: ['See Work Process', 'Project Collaboration', 'Client Reviews']
  },

  // Contact Information
  contact: {
    content: "You can reach mahmud via Email, LinkedIn, and Portfolio.",
    options: ['Schedule Call', 'Send Email', 'View Calendar']
  },
  "schedule call": {
    content: "mahmud is available for a consultation call. Please choose a time slot.",
    options: ['Choose Time', 'Contact mahmud']
  },
  "send email": {
    content: "Send an email to dev@devplus.fun for inquiries.",
    options: ['Open Email Client', 'View Contact Info']
  },
  "view calendar": {
    content: "Check mahmud's availability for meetings.",
    options: ['Check Schedule', 'Book a Meeting']
  },

  // Additional Features
  faq: {
    content: "Have questions? Check out the frequently asked questions section.",
    options: ['View FAQ', 'Ask a Question', 'Contact Support']
  },
  "ask a question": {
    content: "Feel free to ask anything about mahmud’s skills, work process, or services.",
    options: ['Type Your Question', 'View FAQ', 'Contact mahmud']
  },

  // Default Response
  default: {
    content: "I'm here to help! Would you like to know about Skills, Projects, Work Process, or Contact Information?",
    options: ['Skills', 'Projects', 'Process', 'Contact']
  }
};
